/** Company / organization label for hiring response defaults. */
export function resolveHiringCompanyName(user) {
  if (!user || typeof user !== "object") return "";
  const rp = user.recruitmentProfile;
  if (rp && typeof rp.organizationName === "string" && rp.organizationName.trim()) {
    return rp.organizationName.trim();
  }
  if (typeof user.companyName === "string" && user.companyName.trim()) {
    return user.companyName.trim();
  }
  return "";
}

/** Hiring manager name for invite email signatures. */
export function resolveHiringManagerName(user) {
  if (!user || typeof user !== "object") return "";
  const rp = user.recruitmentProfile;
  if (rp && typeof rp.contactName === "string" && rp.contactName.trim()) {
    return rp.contactName.trim();
  }
  if (typeof user.name === "string" && user.name.trim()) {
    return user.name.trim();
  }
  return "";
}

export function buildDefaultResponseSignature(companyName) {
  const company = String(companyName || "").trim();
  if (company) return `Thank you, Hiring team @ ${company}`;
  return "Thank you, Hiring team";
}

/** Placeholder shown in rejection message previews before a real applicant is chosen. */
export const RESPONSE_PREVIEW_APPLICANT_NAME = "Applicant name";
